import { render, staticRenderFns } from "./SettingsOfficeEditModal.vue?vue&type=template&id=8823a912&"
import script from "./SettingsOfficeEditModal.vue?vue&type=script&lang=js&"
export * from "./SettingsOfficeEditModal.vue?vue&type=script&lang=js&"
import style0 from "./SettingsOfficeEditModal.vue?vue&type=style&index=0&id=8823a912&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports